export default __webpack_public_path__ + "static/media/correctans.a4d9de37.png";